/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-compare-table';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const addToBomEndpoint = 'https://www.rockwellautomation.com/my/bom?catalogNumber=${catalogNumber}';
const backupImage = 'https://www.rockwellautomation.com/product-images/${sku}/${sku}.jpg';
const productDetailPath = '/products/details.${catalogNumber}.html';
class ProductCompareTable extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        header: this.element.querySelector(`.${componentName}__header`),
        productGrid: this.element.querySelector(`.${componentName}__grid`),
        gridContainer: this.element.querySelector(`.${componentName}__grid-container`),
        gridHeader: this.element.querySelector(`.${componentName}__grid-header`),
        gridHeaderContainer: this.element.querySelector(`.${componentName}__grid-header-container`),
        closeIcon: this.element.querySelector(`.${componentName}__close-icon`),
        rightChevron: this.element.querySelector(`.${componentName}__right-chevron-icon`),
        openIcon: this.element.querySelector(`.${componentName}__open-icon`),
        placeholder: this.element.querySelector(`.${componentName}__placeholder`),
        // Actions
        actions: this.element.querySelector(`.${componentName}__actions`),
        backButton: this.element.querySelector(`.${componentName}__back-button`),
        hideSimilaritiesCheckbox: this.element.querySelector(`.${componentName} #hide-similarities`),
        highlightDifferencesCheckbox: this.element.querySelector(`.${componentName} #highlight-differences`),
        // emailLink: this.element.querySelector(`.${componentName}__email-link`),
        // printButton: this.element.querySelector(`.${componentName}__print-button`),
    };

    state = {
        userCompareData: [],
        compareValues: [],
        componentOffset: 0,
        locale: document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us',
    };

    constants = {
        app: '',
        defaultImage: 'https://www.rockwellautomation.com/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        defaultCompareValues: [
            { label: 'Brand', value: 'brand' },
        ],
        subnavDesktopHeight: 50,
        subnavMobileHeight: 60,
        headerDesktopHeight: 72,
        headerMobileHeight: 56,
    };

    getProducts = async (catalogNumbers) => {
        try {
            const countryCode = this.state.locale.split('-')[1];
            const response = await fetch(`${productDetailServletEndpoint}?app=${this.constants.app}&catalogNumber=${catalogNumbers.join(',')}&countryCode=${countryCode}`);
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('ISO-8859-2').decode(responseBuffer);
            const responseJson = JSON.parse(responseString);
            if (!Array.isArray(responseJson)) {
                return [responseJson];
            } else {
                return responseJson;
            }
        } catch (error) {
            console.warn('Error:', error);
            return [];
        }
    };

    getCompareValues = (products) => {
        const compareValues = [];
        products.forEach((product) => {
            if (product.classificationFeaturesArray) {
                product.classificationFeaturesArray.forEach((feature) => {
                    if (!compareValues.find((compareValue) => compareValue.value === feature.classification_name) && feature.value !== undefined && feature.value !== null && feature.value !== '') {
                        compareValues.push({ label: feature.classification_name, value: feature.classification_name });
                    }
                });
            }
        });
        return compareValues;
    }

    createGridHeader = (products) => {
        const gridHeader = document.createElement('tr');
        products.forEach((product) => {
            gridHeader.innerHTML += `
                <td class="${componentName}__grid-header-cell ${componentName}__grid-cell--${product.catalogNumber}">
                    <div class="${componentName}__grid-header-cell-container">
                        <div class="${componentName}__product-remove" data-catalog-number="${product.catalogNumber}">${this.elements.closeIcon.outerHTML}</div>
                        ${product.salesOrg_preferredAvailability ? `<div class="${componentName}__product-best-selling">Best Selling</div>` : ''}
                        <div class="${componentName}__product-image-container">
                            <img class="${componentName}__product-image" src="${product.picture_url || this.constants.defaultImage}" alt="${product.names_value}" />
                        </div>
                        <div class="${componentName}__product-text">
                            <a class="${componentName}__product-link ${componentName}__product-link-info" href="/${this.state.locale}${productDetailPath.replace('${catalogNumber}', product.catalogNumber)}">
                                <div class="${componentName}__product-catalog-number">${product.catalogNumber}</div>
                                <div class="${componentName}__product-name">${product.names_value}</div>
                            </a>
                            ${this.constants.app === 'RA' ? `<a class="${componentName}__product-link ${componentName}__product-link-bom" href="${addToBomEndpoint.replace('${catalogNumber}', product.catalogNumber)}">Add to project ${this.elements.openIcon.outerHTML}</a>` : ''}
                        </div>
                    </div>
                </td>`;
        });
        this.elements.gridHeader.innerHTML = '';
        gridHeader.querySelectorAll(`.${componentName}__product-image`).forEach((image) => {
            image.addEventListener('error', () => {
                if (image.getAttribute('src') === this.constants.defaultImage) {
                    return;
                }
                image.setAttribute('src', this.constants.defaultImage);
            });
        });
        this.elements.gridHeader.appendChild(gridHeader);
    }

    createGridRow = (products, compareValue) => {
        const gridRowHeader = document.createElement('tr');
        gridRowHeader.classList.add(`${componentName}__grid-row`);
        gridRowHeader.classList.add(`${componentName}__grid-row-header`);
        gridRowHeader.innerHTML = `<td class="${componentName}__grid-cell ${componentName}__grid-row-header-cell" colspan="${products.length}">${compareValue.label}</td>`;
        const gridRow = document.createElement('tr');
        gridRow.classList.add(`${componentName}__grid-row`);
        let rowValues = [];
        products.forEach((product) => {
            let productValue = null;
            if (product[compareValue.value] === true) {
                productValue = 'Yes';
            } else if (product[compareValue.value] === false) {
                productValue = 'No';
            } else if (product[compareValue.value] !== undefined && product[compareValue.value] !== null && product[compareValue.value] !== '') {
                productValue = product[compareValue.value];
            } else if (product.classificationFeaturesArray) {
                product.classificationFeaturesArray.forEach((feature) => {
                    if (feature.classification_name === compareValue.value) {
                        if (feature.value === true) {
                            productValue = 'Yes';
                        } else if (feature.value === false) {
                            productValue = 'No';
                        } else if (feature.value !== undefined && feature.value !== null && feature.value !== '') {
                            productValue = feature.value;
                        }
                    }
                });
            }
            let valueIndex = -1;
            if (productValue === 'Yes') {
                valueIndex = 'true';
            } else if (productValue === 'No') {
                valueIndex = 'false';
            } else if (productValue !== null) {
                let currentMaxIndex = -1;
                rowValues.forEach((previousValue) => {
                    if (previousValue.value === productValue) {
                        valueIndex = previousValue.index;
                    }
                    currentMaxIndex = Math.max(currentMaxIndex, previousValue.index);
                });
                if (valueIndex === -1) {
                    valueIndex = currentMaxIndex + 1;
                }
            }
            rowValues.push({ value: productValue, index: valueIndex });
            gridRow.innerHTML += `<td class="${componentName}__grid-cell ${componentName}__grid-cell--${product.catalogNumber}" data-value-index=${valueIndex}>${productValue || 'N/A'}</td>`;
        });
        if (rowValues.every((value, index, array) => value.value === array[0].value)) {
            gridRow.classList.add(`${componentName}__grid-row--similarity`);
            gridRowHeader.classList.add(`${componentName}__grid-row--similarity`);
        } else {
            gridRow.classList.add(`${componentName}__grid-row--difference`);
            gridRowHeader.classList.add(`${componentName}__grid-row--difference`);
        }
        this.elements.productGrid.appendChild(gridRowHeader);
        this.elements.productGrid.appendChild(gridRow);
    }

    toggleSimilarRows = () => {
        this.elements.hideSimilaritiesCheckbox.setAttribute("data-var", this.elements.hideSimilaritiesCheckbox.checked ? "checked" : "unchecked");
        const similarRows = this.elements.productGrid.querySelectorAll(`.${componentName}__grid-row--similarity`);
        similarRows.forEach((similarRow) => {
            similarRow.classList.toggle('hidden');
        });
    };

    toggleDifferentRows = () => {
        this.elements.highlightDifferencesCheckbox.setAttribute("data-var", this.elements.highlightDifferencesCheckbox.checked ? "checked" : "unchecked");
        const differentRows = this.elements.productGrid.querySelectorAll(`.${componentName}__grid-row--difference`);
        differentRows.forEach((differentRow) => {
            differentRow.classList.toggle('highlight');
        });
    };

    // printGrid = () => {
    //     window.print();
    // };

    removeProduct = (catalogNumber) => {
        const productCells = document.querySelectorAll(`.${componentName}__grid-cell--${catalogNumber}`);
        productCells.forEach((productCell) => {
            productCell.remove();
        });
        this.state.userCompareData = this.state.userCompareData.filter((data) => data !== catalogNumber);
        window.localStorage.setItem('userCompareData', this.state.userCompareData.join(' '));
        if (this.state.userCompareData.length === 0) {
            this.elements.placeholder.classList.remove('hidden');
            this.elements.productGrid.classList.add('hidden');
            this.elements.header.classList.add('hidden');
        } else {
            const productRowHeaders = document.querySelectorAll(`.${componentName}__grid-row-header-cell`);
            productRowHeaders.forEach((productRowHeader) => {
                productRowHeader.colSpan = this.state.userCompareData.length;
            });
        }
    };

    refreshGrid = async () => {
        window.dispatchEvent(new CustomEvent('show-loading'));
        this.elements.productGrid.innerHTML = '';

        const urlParams = new URLSearchParams(window.location.search);
        const urlProducts = urlParams.get('products');

        if (urlProducts) {
            this.state.userCompareData = urlProducts.split(',');
        } else {
            this.state.userCompareData = window.localStorage.getItem('userCompareData') ? window.localStorage.getItem('userCompareData').split(' ') : [];
        }

        if (this.state.userCompareData.length === 0) {
            this.elements.placeholder.classList.remove('hidden');
            this.elements.productGrid.classList.add('hidden');
            this.elements.header.classList.add('hidden');
        } else {
            this.elements.placeholder.classList.add('hidden');
            this.elements.productGrid.classList.remove('hidden');
            this.elements.header.classList.remove('hidden');
            const catalogNumbers = this.state.userCompareData;
            const products = await this.getProducts(catalogNumbers);
            this.state.compareValues = [...this.constants.defaultCompareValues, ...this.getCompareValues(products)];
            this.createGridHeader(products);

            this.state.compareValues.forEach((compareValue) => {
                this.createGridRow(products, compareValue);
            });

            this.elements.gridHeader.querySelectorAll(`.${componentName}__product-remove`).forEach((removeButton) => {
                removeButton.addEventListener('click', (event) => {
                    const catalogNumber = event.currentTarget.getAttribute('data-catalog-number');
                    this.removeProduct(catalogNumber);
                });
            });

            // Update URL with current comparison list
            const newUrl = `${window.location.pathname}?products=${this.state.userCompareData.join(',')}`;
            window.history.replaceState(null, '', newUrl);

            // Sync to localStorage
            window.localStorage.setItem('userCompareData', this.state.userCompareData.join(' '));
        }

        window.dispatchEvent(new CustomEvent('hide-loading'));
    };

    // Calculate top offset of component
    calculateComponentOffset = () => {
        let offset = 0;
        let subnavOffset = document.querySelector('.sub-nav') ? this.constants.subnavDesktopHeight : 0;
        if (subnavOffset !== 0 && window.innerWidth < 1280) {
            subnavOffset = this.constants.subnavMobileHeight;
        }
        const headerOffset = (window.innerWidth < 1024) ? this.constants.headerMobileHeight : this.constants.headerDesktopHeight;
        if (subnavOffset === 0) {
            offset += headerOffset;
        } else {
            offset += subnavOffset;
        }
        return offset;
    };

    resizeHandler = () => {
        const componentOffset = this.calculateComponentOffset();
        if (this.state.componentOffset !== componentOffset) {
            this.state.componentOffset = componentOffset;
            this.element.style.setProperty(
                '--top-offset',
                `${this.state.componentOffset}px`
            );
        }
    };

    // Listener to sync horizontal scroll of grid header and container
    syncScrollHeader = (event) => {
        this.elements.gridHeaderContainer.scrollLeft = event.target.scrollLeft;
    };
    syncScrollContainer = (event) => {
        this.elements.gridContainer.scrollLeft = event.target.scrollLeft;
    };

    addEventListeners = () => {
        this.elements.hideSimilaritiesCheckbox.addEventListener('change', this.toggleSimilarRows);
        this.elements.highlightDifferencesCheckbox.addEventListener('change', this.toggleDifferentRows);
        // this.elements.printButton.addEventListener('click', this.printGrid);

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && window.localStorage.getItem('userCompareData') !== this.state.userCompareData.join(' ')) {
                this.refreshGrid();
            }
        });
        window.addEventListener('resize', this.resizeHandler);
        this.elements.gridContainer.addEventListener('scroll', this.syncScrollHeader);
        this.elements.gridHeaderContainer.addEventListener('scroll', this.syncScrollContainer);
    };

    initDom = async () => {
        window.dispatchEvent(new CustomEvent('show-loading'));
        this.constants.app = this.elements.container.getAttribute('data-app') ? this.elements.container.getAttribute('data-app') : 'RA';
        await this.refreshGrid();

        if (document.referrer) {
            this.elements.backButton.href = document.referrer;
        } else {
            this.elements.backButton.remove();
        }
        window.dispatchEvent(new CustomEvent('hide-loading'));

        setTimeout(() => {
            this.state.componentOffset = this.calculateComponentOffset();
            this.element.style.setProperty(
                '--top-offset',
                `${this.state.componentOffset}px`
            );
        }, 750);
    };

    /**
     * Initialize Component
     */
    init = async () => {
        await this.initDom();
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, ProductCompareTable);
